module.exports = __webpack_public_path__ + "static/media/siis_image.b6fb3522.png";